<!--  -->
<template>
  <div>
    <div class="banner">
      <img :src="activeData.banner" v-if="activeData.banner" class="imgUrl">
      <div class="btn">
        <div class="btn_1" @click="goActive">
          <img :src="activeData.homepage_navigation">
          <img :src="activeData.homepage_navigation_move">
        </div>
        <div class="btn_2" @click="goActive">
          <img :src="activeData.list_navigation">
          <img :src="activeData.list_navigation_move">
        </div>
        <div class="btn_3" @click="goActive">
          <img :src="activeData.result_navigation">
          <img :src="activeData.result_navigation_move">
        </div>
      </div>
      <img class="upload_1" @click="goActive" :src="activeData.video_one_button" :style="`left:${activeData.video_one_left_margin/100}rem;bottom:${activeData.video_one_bottom_margin/100}rem;`">
      <img class="upload_2" @click="goActive" :src="activeData.image_one_button" :style="`left:${activeData.video_one_left_margin/100 + 2.4 + activeData.image_one_left_margin/100}rem;bottom:${activeData.image_one_bottom_margin/100}rem;`">
    </div>
    <div class="imgBg" v-for="(item,index) in imgUrl" :key="index">
      <img :src="item" class="bg">
      <template v-if="index == imgUrl.length - 1">
        <img class="upload_1" @click="goActive" :src="activeData.video_two_button" :style="`left:${activeData.video_two_left_margin/100}rem;bottom:${activeData.video_two_bottom_margin/100}rem;`">
        <img class="upload_2" @click="goActive" :src="activeData.image_two_button" :style="`left:${activeData.video_two_left_margin/100 + 2.4 + activeData.image_two_left_margin/100}rem;bottom:${activeData.image_two_bottom_margin/100}rem;`">
      </template>
    </div>
  </div>
</template>

<script>
import { find_id } from '../../api/index'
export default {
  name: '',
  components: {},
  data() {
    return {
      activeData: {
        // banner: 'http://source.apumiao.com/mobile/thumbnail/10048348381597410149.jpg',//banner图
        // time: '',//活动时间
        // rule: '',//活动规则
        // reward: '',//活动奖励
        // selection: '',//评选规则
        // uploadBtnVideo: 'http://source.apumiao.com/mobile/thumbnail/10048348381597410149.jpg',
        // uploadBtnVideo_x: '0',
        // uploadBtnVideo_y: '0',
        // uploadBtnImg: 'http://source.apumiao.com/mobile/thumbnail/10048348381597410149.jpg',
        // uploadBtnImg_x: '0',
        // uploadBtnImg_y: '0',
      },
      imgUrl: null,
    };
  },
  created() {
    console.log(this.$route.query.id)
  },
  mounted(){
    this.getActivity()
  },
  computed: {},
  methods: {
    goActive() {
      console.log('123')
      let url = `upupoo://openapp?activity=1&id=${this.$route.query.id}`
      this.clickDownload(url)
    },
    getActivity() {
      find_id({ id: this.$route.query.id }).then(res => {
        if (res.data) {
          this.activeData = res.data
          this.imgUrl = this.activeData.homepage_image.split(',')
        }

      })
    },
    //检查app是否打开
    clickDownload(url) {
      var self = this
      // if (navigator.userAgent.match(/(iPhone|iPod|iPad);?/i)) {
      if (navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)) {
        var loadDateTime = new Date()
        window.location.href = url //schema链接或者universal link
        this.loadTime = window.setTimeout(function () {
          //如果没有安装app,便会执行setTimeout跳转下载页
          var timeOutDateTime = new Date()
          if (timeOutDateTime - loadDateTime < 5000) {
            // alert('没下')
            self.$router.push({ path: '/dl' })
            // window.location = "http://www.upupoo.com"; //ios下载地址
          } else {
            window.close()
          }
        }, 1000)
      } else if (navigator.userAgent.match(/android/i)) {
        try {
          window.location.href = url //schema链接或者universal link
          // window.location.href = url
          this.loadTime = window.setTimeout(function () {
            // alert('没下')
            self.$router.push({ path: '/dl' })
            // window.location = "http://www.upupoo.com"; //android下载地址
          }, 1000)
        } catch (e) { }
      }
    },
  },
}
</script>

<style lang='scss' scoped>
.banner {
  width: 100%;
  position: relative;
  overflow: hidden;
  .imgUrl {
    width: 100%;
  }
  .btn {
    position: absolute;
    top: 0;
    left: 50%;
    transform: translate(-50%, 0);
    display: flex;
    .btn_1,
    .btn_2,
    .btn_3 {
      cursor: pointer;
      margin-right: 0.24rem;
      img {
        width: 1.7rem;
        &:nth-child(1) {
          display: block;
        }
        &:nth-child(2) {
          display: none;
        }
      }
      &:hover {
        img {
          &:nth-child(1) {
            display: none;
          }
          &:nth-child(2) {
            display: block;
          }
        }
      }
    }
    .btn_3{
      margin-right: 0;
    }
  }
  .upload_1,
  .upload_2 {
    position: absolute;
    width: 2.4rem;
    cursor: pointer;
    bottom: 0.25rem;
  }
  .upload_1{
    left: calc((100% - 4.8rem)/3);
  }
  .upload_2{
    left: calc((100% - 4.8rem)/3 + 2.4rem + (100% - 4.8rem)/3);
  }
}
.imgBg {
  width: 100%;
  position: relative;
  .bg {
    width: 100%;
  }
  .upload_1,
  .upload_2 {
    position: absolute;
    width: 2.4rem;
    cursor: pointer;
    bottom: 0.25rem;
  }
  .upload_1{
    left: calc((100% - 4.8rem)/3);
  }
  .upload_2{
    left: calc((100% - 4.8rem)/3 + 2.4rem + (100% - 4.8rem)/3);
  }
}
</style>